import { MatElementsModule } from './../_modules/mat-elements.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';


import { FeePaymentRoutingModule } from './fee-payment-routing.module';
import { PaylayoutComponent } from './paylayout.component';
import { PayStudentComponent } from './pay-student.component';

import { MatIconModule } from '@angular/material/icon';
import { CaptureResponseComponent } from './capture-response.component';

@NgModule({

  imports: [
    CommonModule,
    ReactiveFormsModule,
    FeePaymentRoutingModule,
    MatElementsModule,
    MatIconModule
  ],
  declarations: [
    PaylayoutComponent,
    PayStudentComponent,
    CaptureResponseComponent
  ]
})
export class FeePaymentModule { }
